module.exports = __webpack_public_path__ + "img/bigleft1.f8d22de2.svg";